export default __webpack_public_path__ + "static/media/avatar_mei_ling1.14247f45.mp3";